/** Публичный URL сайта (canonical, Open Graph). Переопределение: REACT_APP_SITE_URL */
const raw =
  (typeof process !== "undefined" && process.env.REACT_APP_SITE_URL) ||
  "https://bay-sport.ru";

export const SITE_ORIGIN = String(raw).replace(/\/$/, "");

export const SITE_NAME = "Бай.Спорт";

export const DEFAULT_DESCRIPTION =
  "Бай.Спорт — CRM для спортивных клубов, секций и студий: расписание, журнал посещений, абонементы, оплаты и приложение для клиентов. 7 дней бесплатно, от 1 500 ₽/мес.";
